var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"portal-content-wrap"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('MyInfoWebpart')],1),_c('div',{staticClass:"col-9"},[_c('MyCountWebpart',{attrs:{"isMailUser":_vm.isMailUser}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }